import { render, staticRenderFns } from "./competitionWorkInfo.vue?vue&type=template&id=2edde467&scoped=true&lang=html&"
import script from "./competitionWorkInfo.vue?vue&type=script&lang=js&"
export * from "./competitionWorkInfo.vue?vue&type=script&lang=js&"
import style0 from "./competitionWorkInfo.vue?vue&type=style&index=0&id=2edde467&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edde467",
  null
  
)

export default component.exports